import React from "react";
import classNames from "classnames";
import styles from "./botCard.css";

interface Props {
  title: string;
  isActive?: boolean;
  onClick: () => void;
  logoElement: JSX.Element;
}

export const BotCard = ({ title, isActive, onClick, logoElement }: Props) => {
  const renderContent = () => (
    <div className={styles["title-container"]}>
      <div className={styles["logo-container"]}>{logoElement}</div>
      <p className={styles.title}>{title}</p>
    </div>
  );

  return (
    <div
      className={classNames(styles.container, { [styles["active-border"]]: isActive })}
      onClick={onClick}
    >
      {renderContent()}
    </div>
  );
};
